import React, { useEffect } from 'react';
import { MapContainer, TileLayer, CircleMarker, Polyline, Tooltip, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

const Fit = ({ points }) => {
  const map = useMap();
  useEffect(() => {
    const valid = points.filter(Boolean);
    if (valid.length === 1) map.setView([valid[0].lat, valid[0].lng], 13);
    else if (valid.length > 1) {
      const lats = valid.map((p) => p.lat); const lngs = valid.map((p) => p.lng);
      map.fitBounds([[Math.min(...lats), Math.min(...lngs)], [Math.max(...lats), Math.max(...lngs)]], { padding: [40, 40], maxZoom: 14 });
    }
  }, [points, map]);
  return null;
};

const LiveMap = ({ property, contractor, history = [], height = 280 }) => {
  const center = contractor || property || { lat: 51.5074, lng: -0.1278 };
  const line = [...history.map((h) => [h.lat, h.lng])];
  if (contractor && property) line.push([property.lat, property.lng]);

  return (
    <div className="relative isolate z-0 rounded-2xl overflow-hidden border border-border" style={{ height }}>
      <MapContainer center={[center.lat, center.lng]} zoom={13} style={{ height: '100%', width: '100%' }} scrollWheelZoom={false}>
        <TileLayer attribution='&copy; OpenStreetMap' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {line.length > 1 && <Polyline positions={line} pathOptions={{ color: '#1c63c4', weight: 3, dashArray: '6 8' }} />}
        {property && (
          <CircleMarker center={[property.lat, property.lng]} radius={9} pathOptions={{ color: '#0b2244', fillColor: '#102d55', fillOpacity: 1 }}>
            <Tooltip permanent direction="top">Property</Tooltip>
          </CircleMarker>
        )}
        {contractor && (
          <CircleMarker center={[contractor.lat, contractor.lng]} radius={8} pathOptions={{ color: '#15803d', fillColor: '#22c55e', fillOpacity: 1 }}>
            <Tooltip permanent direction="bottom">Contractor</Tooltip>
          </CircleMarker>
        )}
        <Fit points={[property, contractor]} />
      </MapContainer>
    </div>
  );
};

export default LiveMap;
